import { render, staticRenderFns } from "./Pos-counter-checkout.vue?vue&type=template&id=2a814de3&"
import script from "./Pos-counter-checkout.vue?vue&type=script&lang=js&"
export * from "./Pos-counter-checkout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports